import { Action } from 'redux';

import {
    REQUEST_ORDER_LINK,
    RESPONSE_ORDER_LINK,
    ERROR_ORDER_LINK,

    SET_BOOKING_GUESTS,
    ADD_BOOKING_GUESTS,
    SET_EMAIL,

    REQUEST_ORDER_PAYLOAD,
    RESPONSE_ORDER_PAYLOAD,
    ERROR_ORDER_PAYLOAD,
    RESPONSE_STATUS_NAMES,
    ERROR_STATUS_NAMES,
    REQUEST_CANCEL_ORDER,
    ERROR_CANCEL_ORDER,
    RESPONSE_CANCEL_ORDER,
    REQUEST_ORDERS,
    RESPONSE_ORDERS,
    ERROR_ORDERS,
    REQUEST_DELETE_ORDER,
    RESPONSE_DELETE_ORDER,
    ERROR_DELETE_ORDER,
    CHANGE_ORDER_STATUS
} from '../../actions/Hotels/orders';
import { OrderedMap } from 'immutable';
import { Guest } from '../../models/Hotels/Guest';
import { Order } from '../../models/Hotels/Orders';
import i18next from 'i18next';

export interface HotelsOrdersState {
    orderLink: string | null;
    orderLoading: boolean;
    orderError: string | null;

    email: string;
    bookingGuests: OrderedMap<number, Guest>;
    countBookingGuests: number;

    orderPayloadLink: string;
    loadingOrderPayload: boolean;
    errorOrderPayload: any;

    statusNames: Array<string>;
    loadingStatusNames: boolean;
    errorStatusNames: any;

    orders: Array<Order>;
    loadingOrders: boolean;
    errorOrders: any;
    pageOrders: number | null;

    canceledOrder: boolean | null;
    loadingCancelOrder: boolean;
    errorCancelOrder: any;

    deletedOrder: boolean | null;
    loadingDeleteOrder: boolean;
    errorDeleteOrder: any;

    voucher: any;
    loadingVoucher: boolean;
    errorVoucher: any;

    digestChanged: string | null;
}

const initialState: HotelsOrdersState = {
    orderLink: null,
    orderLoading: false,
    orderError: null,

    email: '',
    bookingGuests: OrderedMap<number, Guest>().set(0, {
        first_name: '',
        last_name: ''
    }),
    countBookingGuests: 1,

    orderPayloadLink: '',
    loadingOrderPayload: false,
    errorOrderPayload: null,

    statusNames: Array<string>(),
    loadingStatusNames: false,
    errorStatusNames: null,

    orders: Array<Order>(),
    loadingOrders: false,
    errorOrders: null,
    pageOrders: 1,

    canceledOrder: null,
    loadingCancelOrder: false,
    errorCancelOrder: null,

    deletedOrder: null,
    loadingDeleteOrder: false,
    errorDeleteOrder: null,

    voucher: null,
    loadingVoucher: false,
    errorVoucher: null,

    digestChanged: null
};

export function hotelsOrdersState(state: HotelsOrdersState = initialState, action: Action) {
    switch (action.type) {
        case REQUEST_ORDER_PAYLOAD: {
            return {
                ...state,
                loadingOrderPayload: true,
                errorOrderPayload: initialState.errorOrderPayload,
                orderPayloadLink: initialState.orderPayloadLink
            };
        }
        case RESPONSE_ORDER_PAYLOAD: {
            const {response} = (action as any);
            const orderPayloadLink = response.result.form_url;
            return {
                ...state,
                orderPayloadLink,
                loadingOrderPayload: false
            };
        }
        case ERROR_ORDER_PAYLOAD: {
            const {error} = (action as any);
            return {
                ...state,
                loadingOrderPayload: false,
                errorOrderPayload: error
            };
        }
        case SET_BOOKING_GUESTS: {
            return {
                ...state,
                bookingGuests: (action as any).guests
            };
        }
        case ADD_BOOKING_GUESTS: {
            return {
                ...state,
                countBookingGuests: state.countBookingGuests + 1
            };
        }
        case SET_EMAIL: {
            return {
                ...state,
                email: (action as any).email
            };
        }
        case REQUEST_ORDER_LINK: {
            return {
                ...state,
                orderLoading: true,
                orderError: initialState.orderError,
                orderLink: initialState.orderLink
            };
        }
        case RESPONSE_ORDER_LINK: {
            const response = (action as any).response;
            if (response.result) {
                return {
                    ...state,
                    orderLoading: false,
                    orderLink: response.result
                };
            } else {
                return {
                    ...state,
                    orderLoading: false,
                    orderError: 'No result node in response JSON'
                };
            }
        }
        case ERROR_ORDER_LINK: {
            const orderError = (action as any).error;
            console.log(orderError);
            alert(i18next.t('error_contact_konsierge'));
            return {
                ...state,
                orderLoading: false
            };
        }
        case RESPONSE_STATUS_NAMES: {
            const statusNames = (action as any).response.result;
            return {
                ...state,
                errorStatusNames: initialState.errorStatusNames,
                statusNames
            };
        }
        case ERROR_STATUS_NAMES: {
            const errorStatusNames = (action as any).error;
            console.log(errorStatusNames);
            return {
                ...state,
                errorStatusNames
            };
        }
        case REQUEST_ORDERS: {
            return {
                ...state,
                loadingOrders: true,
                orders: initialState.orders,
                errorOrders: initialState.errorOrders
            };
        }
        case RESPONSE_ORDERS: {
            const orders = (action as any).response.result;
            const pageOrders = (action as any).response.page.next_page;
            return {
                ...state,
                loadingOrders: false,
                orders,
                pageOrders
            };
        }
        case ERROR_ORDERS: {
            const errorOrders = (action as any).error;
            console.log(errorOrders);
            alert(i18next.t('error_contact_konsierge'));
            return {
                ...state,
                loadingOrders: false,
            };
        }
        case REQUEST_CANCEL_ORDER: {
            const digestChanged = (action as any).digest;
            return {
                ...state,
                loadingCancelOrder: true,
                canceledOrder: initialState.canceledOrder,
                errorCancelOrder: initialState.errorCancelOrder,
                digestChanged
            };
        }
        case RESPONSE_CANCEL_ORDER: {
            const canceledOrder = (action as any).response.result;
            const orders: Array<Order> = Array<Order>();
            state.orders.map(order => {
                let changedOrder: Order = order;
                if (order.digest === state.digestChanged) {
                    changedOrder.status = 'cancelled';
                }
                orders.push(changedOrder);
            });
            return {
                ...state,
                loadingCancelOrder: false,
                canceledOrder,
                digestChanged: initialState.digestChanged,
                orders
            };
        }
        case ERROR_CANCEL_ORDER: {
            const errorCancelOrder = (action as any).error;
            console.log(errorCancelOrder);
            alert(i18next.t('error_contact_konsierge'));
            return {
                ...state,
                loadingCancelOrder: false,
                digestChanged: initialState.digestChanged
            };
        }
        case REQUEST_DELETE_ORDER: {
            const digestChanged = (action as any).digest;
            return {
                ...state,
                loadingDeleteOrder: true,
                deletedOrder: initialState.deletedOrder,
                errorDeleteOrder: initialState.errorDeleteOrder,
                digestChanged
            };
        }
        case RESPONSE_DELETE_ORDER: {
            const deletedOrder = (action as any).response.result;
            const orders = state.orders.filter(order => order.digest !== state.digestChanged);
            return {
                ...state,
                loadingDeleteOrder: false,
                deletedOrder,
                orders,
                digestChanged: initialState.digestChanged
            };
        }
        case ERROR_DELETE_ORDER: {
            const errorDeleteOrder = (action as any).error;
            console.log(errorDeleteOrder);
            alert(i18next.t('error_contact_konsierge'));
            return {
                ...state,
                loadingDeleteOrder: false,
                digestChanged: initialState.digestChanged
            };
        }
        case CHANGE_ORDER_STATUS: {
            const digest = (action as any).digest;
            const status = (action as any).status;
            let orders: Array<Order> = Array<Order>();
            state.orders.map(order => {
                if (order.digest === digest) {
                    let newOrder = order;
                    newOrder.status = status;
                    orders.push(newOrder);
                } else {
                    orders.push(order);
                }
            });
            return {
                ...state,
                orders
            };
        }
        /*case REQUEST_VOUCHER: {
            return {
                ...state,
                loadingVoucher: true,
                voucher: initialState.voucher,
                errorVoucher: initialState.errorVoucher
            };
        }
        case RESPONSE_VOUCHER: {
            const voucher = (action as any);
            console.log(voucher);
            return {
                ...state,
                loadingVoucher: false,
                voucher
            };
        }
        case ERROR_VOUCHER: {
            const errorVoucher = (action as any).error;
            console.log(errorVoucher);
            alert(i18next.t('error_contact_konsierge'));
            return {
                ...state,
                loadingVoucher: false,
            };
        }*/
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Hotels/orders.ts